/* Component Dependencies */
var golfServicesTemplate = require('templates/golfServices.hbs');
var golfServicesLiteTemplate = require('templates/golfServices-lite.hbs');
var golfServicesnearbyTemplate = require('templates/golfServices-nearby.hbs');
var golfServicesclubHighlightsTemplate = require('templates/golfServices-clubHighlights.hbs');
var golfServicesclubHighlightsAsListTemplate = require('templates/golfServices-clubHighlightsAsList.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'golfServices',
  template: {
    'golfServices': golfServicesTemplate,
    'golfServices-lite': golfServicesLiteTemplate,
    'golfServices-nearby': golfServicesnearbyTemplate,
    'golfServices-clubHighlights': golfServicesclubHighlightsTemplate,
    'golfServices-clubHighlightsAsList': golfServicesclubHighlightsAsListTemplate
  }
});
